import { render, staticRenderFns } from "./NotesDetails.vue?vue&type=template&id=44499074&scoped=true"
import script from "./NotesDetails.vue?vue&type=script&lang=js"
export * from "./NotesDetails.vue?vue&type=script&lang=js"
import style0 from "./NotesDetails.vue?vue&type=style&index=0&id=44499074&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44499074",
  null
  
)

export default component.exports